module.exports = __webpack_public_path__ + "static/media/website-13.528d248a.png";